<template>
  <Header />
  <Herosection />
  <Prayers />
  <Footer />
</template>

<script>
import Header from "@/components/Header.vue";
import Herosection from "@/components/HeroSectionPage.vue";
import Footer from "@/components/Footer.vue";
import Prayers from "@/components/views/Prayers.vue";

export default {
  components: {
    Header,
    Herosection,
    Footer,
    Prayers,
  },
};
</script>
